import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import companyReducer from "./slices/companySlice";
import vehicleSpecReducer from "./slices/vehicleSpecSlice";
import packagingReducer from "./slices/packagingSlice";

const rootReducer = combineReducers({
	auth: authReducer,
	company: companyReducer,
	vehicles: vehicleSpecReducer,
	packaging: packagingReducer,
});

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
	devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
